/* Merchant arrival estimates, not carrier guarantees.
 * Reviewed 29 Oct 2026, coverage 2026-01-01 through 2027-12-31.
 * US observed federal dates: https://www.opm.gov/policy-data-oversight/pay-leave/federal-holidays/
 * Includes 31 Dec 2027 (observed New Year 2028). DE conservative union of
 * national/regional dates: https://www.trade.gov/german-holidays
 * Warehouse exclusions: England/Wales https://www.gov.uk/bank-holidays.json
 * Regional exclusions are conservative because the cart has no postcode.
 * Checkout supplies the selected transit window; this never changes its rate.
 */
(function (root, factory) {
  var reference = typeof module === 'object' && module.exports
    ? require('./bf-international-holidays.js') : root.dsrcvBfInternationalHolidays;
  var calendar = factory(reference);
  if (typeof module === 'object' && module.exports) module.exports = calendar;
  else root.dsrcvMerchantArrival = calendar;
}(typeof window !== 'undefined' ? window : this, function (internationalReference) {
  'use strict';
  var from = '2026-01-01', through = '2027-12-31';
  var holidays = {"US":["2026-01-01","2026-01-19","2026-02-16","2026-05-25","2026-06-19","2026-07-03","2026-09-07","2026-10-12","2026-11-11","2026-11-26","2026-12-25","2027-01-01","2027-01-18","2027-02-15","2027-05-31","2027-06-18","2027-07-05","2027-09-06","2027-10-11","2027-11-11","2027-11-25","2027-12-24","2027-12-31"],"DE":["2026-01-01","2026-01-06","2026-03-08","2026-04-03","2026-04-06","2026-05-01","2026-05-14","2026-05-25","2026-06-04","2026-08-15","2026-09-20","2026-10-03","2026-10-31","2026-11-01","2026-11-18","2026-12-25","2026-12-26","2027-01-01","2027-01-06","2027-03-08","2027-03-26","2027-03-29","2027-05-01","2027-05-06","2027-05-17","2027-05-27","2027-08-15","2027-09-20","2027-10-03","2027-10-31","2027-11-01","2027-11-17","2027-12-25","2027-12-26"]};
  var warehouseClosures = ["2026-01-01","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-08-31","2026-12-25","2026-12-28","2027-01-01","2027-03-26","2027-03-29","2027-05-03","2027-05-31","2027-08-30","2027-12-27","2027-12-28"];
  // UK next-day service follows the existing Royal Mail Mon-Sat calendar.
  // Without a postcode, exclude the union of UK regional bank holidays.
  // https://www.royalmail.com/receiving/delivery-times
  holidays.GB = ["2026-01-01","2026-01-02","2026-03-17","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-06-15","2026-07-13","2026-08-03","2026-08-31","2026-11-30","2026-12-25","2026-12-26","2026-12-28","2027-01-01","2027-01-04","2027-03-17","2027-03-26","2027-03-29","2027-05-03","2027-05-31","2027-07-12","2027-08-02","2027-08-30","2027-11-30","2027-12-25","2027-12-26","2027-12-27","2027-12-28"];
  function key(date) { return date.toISOString().slice(0, 10); }
  function parse(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    var date = new Date(value + 'T12:00:00Z');
    return Number.isFinite(date.getTime()) && key(date) === value ? date : null;
  }
  function hasDestinationCalendar(country) {
    return Object.prototype.hasOwnProperty.call(holidays, country) || !!(internationalReference && internationalReference.holidays &&
      Object.prototype.hasOwnProperty.call(internationalReference.holidays, country));
  }
  function transit(country, label, internationalEstimate) {
    if (!holidays[country] && !(internationalEstimate && /^[A-Z]{2}$/.test(country))) return null;
    var value = String(label || '').trim()
      .replace(/\s+-\s+(?:Pre-order Items Ship On Their Listed Date|Ships When Pre-orders Are In Stock)\s*$/i, '')
      .replace(/\s*\(No Import Charges On Delivery\)\s*$/i, '')
      .replace(/^Standard Shipping\s*\|\s*/i, '');
    if (country === 'GB') return /^Delivered Next Day Once Dispatched$/i.test(value) ? { min: 1, max: 1 } : null;
    var match = value.match(/^(\d+)(?:\s*[-–]\s*(\d+))?\s+(?:(working|business)\s+)?days?$/i);
    if (!match) return null;
    var min = Number(match[1]), max = Number(match[2] || match[1]);
    if (min < 1 || max < min || max > 60) return null;
    // Preserve reviewed plain-day mappings outside BF. Ben's BF instruction
    // uses calendar days unless the selected label says working/business days.
    if (!internationalEstimate && !match[3] && !((country === 'US' && min === 4 && max === 10) ||
        (country === 'DE' && min === 7 && max === 9))) return null;
    return { min: min, max: max, calendarDays: !!internationalEstimate && !match[3] };
  }
  function add(date, count, country, internationalEstimate) {
    // Explicit working/business-day services use the merchant Mon–Fri week.
    // Retain reviewed destination exclusions where available; other markets
    // use UK-origin closures, without claiming a carrier/postcode calendar.
    var destinationClosures = internationalEstimate && internationalReference && internationalReference.holidays[country];
    var closures = holidays[country] || (destinationClosures ? destinationClosures.concat(warehouseClosures) : internationalEstimate ? warehouseClosures : null);
    if (!closures) return null;
    var next = new Date(date.getTime());
    for (var attempts = 0; count > 0 && attempts < 365; attempts++) {
      next.setUTCDate(next.getUTCDate() + 1);
      var value = key(next);
      if (value > through) return null;
      if (next.getUTCDay() > 0 && next.getUTCDay() < (country === 'GB' ? 7 : 6) && closures.indexOf(value) === -1) count--;
    }
    return count === 0 ? next : null;
  }
  function range(country, label, dispatchDate, internationalEstimate) {
    var date = parse(dispatchDate), days = transit(country, label, internationalEstimate);
    if (!date || !days || dispatchDate < from || dispatchDate > through) return null;
    var first = days.calendarDays ? new Date(date.getTime() + days.min * 86400000) : add(date, days.min, country, internationalEstimate);
    var last = days.calendarDays ? new Date(date.getTime() + days.max * 86400000) : add(date, days.max, country, internationalEstimate);
    if (first && key(first) > through || last && key(last) > through) return null;
    return first && last ? { min: key(first), max: key(last) } : null;
  }
  function properties(item) {
    var value = item && item.properties;
    return Array.isArray(value) ? Object.fromEntries(value) : value || {};
  }
  function propertyKey(items) {
    return JSON.stringify(items.map(function (item) {
      var props = properties(item);
      return [String(item.key || ''), Object.keys(props).sort().map(function (name) { return [name, String(props[name])]; })];
    }).sort(function (a, b) { return a[0].localeCompare(b[0]); }));
  }
  function publicDate(text) {
    var months = ['january','february','march','april','may','june','july','august','september','october','november','december'];
    var value = String(text || '').toLowerCase(), candidates = [], match;
    // Only an original public estimated shipping/despatch date is an anchor.
    if (!/(?:estimated\s+(?:shipping|despatch|dispatch)\s+date)/.test(value)) return null;
    var pattern = /\b(\d{4}-\d{2}-\d{2})\b|\b(\d{1,2})\s+([a-z]+)\s+(\d{4})\b|\b([a-z]+)\s+(\d{1,2}),?\s+(\d{4})\b/g;
    while ((match = pattern.exec(value))) {
      var iso = match[1];
      if (!iso) {
        var month = months.indexOf(match[3] || match[5]) + 1;
        if (!month) return null;
        iso = (match[4] || match[7]) + '-' + String(month).padStart(2, '0') + '-' + String(match[2] || match[6]).padStart(2, '0');
      }
      if (!parse(iso)) return null;
      candidates.push(iso);
    }
    // A range or conflicting public dates need their original line reviewed.
    if (!candidates.length || candidates.some(function (date) { return date !== candidates[0]; }) ||
        /\b(?:to|between|from)\b|\d\s*[-–]\s*\d/.test(value.replace(/\d{4}-\d{2}-\d{2}/g, ''))) return null;
    return candidates[0];
  }
  function preorderDispatch(items, today) {
    if (!parse(today) || !items || !items.length) return null;
    var dates = items.map(function (item) {
      var props = properties(item), publicDates = [];
      Object.keys(props).forEach(function (name) {
        if (/^(?:notice|estimated (?:shipping|despatch|dispatch) date)$/i.test(name.trim())) {
          publicDates.push(publicDate(name.toLowerCase() === 'notice' ? props[name] : name + ': ' + props[name]));
        }
      });
      if (!publicDates.length || publicDates.some(function (date) {
        var parsed = parse(date);
        return !parsed || date < today || date !== publicDates[0] || parsed.getUTCDay() === 0 ||
          parsed.getUTCDay() === 6 || warehouseClosures.indexOf(date) !== -1;
      })) return null;
      return publicDates[0];
    });
    if (dates.some(function (date) { return !date; })) return null;
    dates.sort();
    return dates[dates.length - 1];
  }
  function format(value, country, locale) {
    var first = value && parse(value.min), last = value && parse(value.max);
    if (!first || !last || first > last) return '';
    var language = locale && !/^en(?:-|$)/i.test(locale) ? locale : country === 'US' ? 'en-US' : 'en-GB';
    var formatter = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'long', timeZone: 'UTC' });
    return 'Estimated arrival ' + (first.getTime() === last.getTime() ? formatter.format(first)
      : first.getUTCFullYear() !== last.getUTCFullYear() ? formatter.format(first) + ' – ' + formatter.format(last)
      : formatter.formatRange(first, last));
  }
  function ukPreorderRange(label, items, today, cutoffPassed) {
    var dispatch = preorderDispatch(items, today);
    if (!dispatch || !transit('GB', label) || dispatch < from || dispatch > through) return null;
    // A future public Notice is already a scheduled despatch date. Today's
    // order cutoff applies only if that date is today, never a second BF wait.
    if (dispatch === today && cutoffPassed) {
      var next = parse(dispatch);
      do { next.setUTCDate(next.getUTCDate() + 1); dispatch = key(next); }
      while (dispatch <= through && (next.getUTCDay() === 0 || next.getUTCDay() === 6 || warehouseClosures.indexOf(dispatch) !== -1));
    }
    return range('GB', label, dispatch);
  }
  return { range: range, transit: transit, hasDestinationCalendar: hasDestinationCalendar, preorderDispatch: preorderDispatch, propertyKey: propertyKey, format: format,
    ukPreorderRange: ukPreorderRange, reviewedFrom: from, reviewedThrough: through };
}));
